module.exports = __webpack_public_path__ + "img/532m2.b6736195.svg";